import {useState} from 'react';

import useMountEffect from '@patientpattern/utils/hooks/useMountEffect';

import {useRefreshToken} from 'user/api';
import {useUserStore} from 'user/store';

export default function useTokenRefresh(onError: (error: unknown) => void) {
    const {mutate: refreshToken} = useRefreshToken();
    const fetch = useUserStore(state => state.fetch);
    const [, setError] = useState(null);

    useMountEffect(() => {
        // try to refresh the auth token first in case they come from legacy and have been there longer than allowed time
        // that it takes to refresh the token (45 minutes) so they don't get automatically logged out here
        refreshToken(undefined, {
            onError,
            onSuccess: () => {
                fetch().catch(error => {
                    if (error instanceof Error) {
                        error.message = `Could not load initialization data: ${error.message.replace(
                            'Error: ',
                            '',
                        )}.`;
                    }

                    // catch async error and re-throw it so that ErrorBoundary picks it up
                    // https://medium.com/trabe/catching-asynchronous-errors-in-react-using-error-boundaries-5e8a5fd7b971
                    setError(() => {
                        throw error;
                    });
                });
            },
        });
    });
}
